var map = {
	"./template.bet777": 1029,
	"./template.bet777.tsx": 1029,
	"./template.betprofessor": 1030,
	"./template.betprofessor.tsx": 1030,
	"./template.betroyale": 1031,
	"./template.betroyale.tsx": 1031,
	"./template.buffalobet": 1032,
	"./template.buffalobet.tsx": 1032,
	"./template.default": 652,
	"./template.default.tsx": 652,
	"./template.fiestabet": 1033,
	"./template.fiestabet.tsx": 1033,
	"./template.forsport": 1034,
	"./template.forsport.tsx": 1034,
	"./template.goldenrush": 1035,
	"./template.goldenrush.tsx": 1035,
	"./template.oldgill": 1036,
	"./template.oldgill.tsx": 1036,
	"./template.puntcity": 1037,
	"./template.puntcity.tsx": 1037,
	"./template.puntgenie": 1038,
	"./template.puntgenie.tsx": 1038,
	"./template.questbet": 1039,
	"./template.questbet.tsx": 1039,
	"./template.ts": 963,
	"./template.volcanobet": 1040,
	"./template.volcanobet.tsx": 1040,
	"./template.wellbet": 1041,
	"./template.wellbet.tsx": 1041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2325;